import { createActionThunk } from "redux-thunk-actions";
import {
  INFO_AND_SUPPORT_INITIALIZATION,
  ON_CHANGE_FEEDBACK_FORM,
  ON_SUBMIT_FEEDBACK,
  RESET_FEEDBACK_PAGE,
  SAVE_FEEDBACK_DRAFT,
  GET_TRANSACTIONS_LIST,
  CLEAR_DIRTY_DRAFT,
} from "./constant";
import {
  feedbackSubmit as feedbackSubmitService,
  getCredit,
  getTransActions,
} from "../services/SupportService";

const initialize = createActionThunk(
  INFO_AND_SUPPORT_INITIALIZATION,
  async (date, userID) => {
    let creditAmount = await getCredit();
    return { creditAmount };
  }
);

const feedbackSubmit = createActionThunk(ON_SUBMIT_FEEDBACK, (feed) =>
  feedbackSubmitService(feed)
);
const tansActionsList = createActionThunk(
  GET_TRANSACTIONS_LIST,
  async () => await getTransActions()
);
const onChangeForm = (e, name, prevBody) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_FEEDBACK_FORM,
      value: e,
      name: name,
      prevBody,
    });
  };
};

const resetPage = (clear) => {
  return (dispatch) => {
    dispatch({
      type: RESET_FEEDBACK_PAGE,
      clear,
    });
  };
};

const saveDraft = () => {
  return (dispatch) => {
    dispatch({
      type: SAVE_FEEDBACK_DRAFT,
    });
  };
};

const clearDirtyDraft = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_DIRTY_DRAFT,
    });
  };
};

export default {
  initialize,
  onChangeForm,
  feedbackSubmit,
  resetPage,
  saveDraft,
  tansActionsList,
  clearDirtyDraft,
};



// WEBPACK FOOTER //
// ./src/actions/infoAndSupportActions.js